<template>
    <div class="asp-ratio r-4-3">
        <div class="asp-ratio-child">
            <div v-show="!data.loaded" class="bg-zircon wd-full ht-full"></div>
            <div v-show="data.loaded" class="wd-full ht-full">
                <div class="pos-rel wd-full ht-full person-cover-img" :style="{'background-image': `url(${(data.image !== '') ? data.image : defaultImage})`}">
                    <div class="pos-abs tp-init bt-init lt-init rt-init">
                        <div class="dp-fx fx-al-end ht-full">
                            <div class="tint-section wd-full">
                                <div class="dp-fx fx-dr-col fx-al-ct cl-white pd-l-20 pd-r-20 pd-b-20 pd-t-30">
                                    <div class="fz-30 tx-ct fw-7">{{data.title}}</div>
                                    <div class="fz-14 tx-ct fw-4">{{data.subtitle}}</div>
                                    <div class="dp-fx fx-al-st fx-js-bw wd-full mg-t-10">
                                        <div class="fz-14 lh-18" v-for="item in data.primaryInfo" :key="item.id" :style="{width : 100/(data.primaryInfo.length) + '%'}">
                                            <div class="fw-7 tx-ct">{{item.title}}</div>
                                            <div class="fw-4 tx-ct">{{item.subtitle}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name : 'PersonCover',
        props : {
            data : Object
        },
        data : function () {
            return {
                defaultImage : require('../assets/default-person.png')
            }
        },
        methods : {}
    }
</script>

<style>
    .person-cover-img{
        background-size: cover;
        background-position: center;
    }
    .person-cover-img .tint-section{
        background: linear-gradient(180deg, rgba(0,0,0,0.00) 0%, #000000 100%);
    }
    .asp-ratio{
        position: relative;
        width: 100%;
    }
    .asp-ratio.r-4-3{
        padding-top: 75%;
    }
    .asp-ratio .asp-ratio-child{
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }
</style>